import {  TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import React from 'react';
import { checkPermission } from '../../utils_v2';
const ActiveUserHeader = ({createSortHandler, sortInfo,}) => {
    return(
        <TableHead>
            <TableRow>
                <TableCell style={{position: 'sticky', left: 0, zIndex: 4, backgroundColor: '#B5BEDB', minWidth:'170px', maxWidth:'220px', whiteSpace:'nowrap'}}>
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true:false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                </TableCell>
                <TableCell style={{minWidth:'220px', whiteSpace:'nowrap'}}>
                    <TableSortLabel
                        active={sortInfo.sort === 'email' ? true:false}
                        direction={sortInfo.sort === 'email' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('email')}
                    >
                        Email
                    </TableSortLabel>
                </TableCell>
                <TableCell style={{minWidth:'170px', maxWidth:'220px', whiteSpace:'nowrap'}}>Designation</TableCell>
                <TableCell style={{minWidth:'160px'}}>
                    <TableSortLabel
                        active={sortInfo.sort === 'date_joined' ? true:false}
                        direction={sortInfo.sort === 'date_joined' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('date_joined')}
                    >
                        Account Created
                    </TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel
                        active={sortInfo.sort === 'last_login' ? true:false}
                        direction={sortInfo.sort === 'last_login' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('last_login')}
                    >
                        Last Login
                    </TableSortLabel>
                </TableCell>
                <TableCell>Status</TableCell>
                 {checkPermission('settings', 'manage_user','U') ? <TableCell style={{position: 'sticky', right: 0, zIndex: 4, backgroundColor: '#B5BEDB', minWidth:'140px', whiteSpace:'nowrap'}}> Action </TableCell>: null }
            </TableRow>
        </TableHead>
    )
}
export default ActiveUserHeader;
